import { render } from "@/components/pages/dataRecollection/workSupport/dataMonitor/DataMonitorMeasureList.html?vue&type=template&id=010752fe&scoped=true&external"
import script from "@/components/pages/dataRecollection/workSupport/dataMonitor/DataMonitorMeasureList.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/workSupport/dataMonitor/DataMonitorMeasureList.js?vue&type=script&lang=js&external"

import "@/components/pages/dataRecollection/workSupport/dataMonitor/DataMonitorMeasureList.scss?vue&type=style&index=0&id=010752fe&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010752fe"]])

export default __exports__